import { Layout, Steps } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setStep } from '../../../shared/store/onboardSlice';

import CreatingBot from './pages/CreatingBot';
import Complete from './pages/CompleteNew';
import styles from './onboard.module.scss';
import CustomAlert from '../../../components/CustomAlert';

const Onboard = () => {
  const dispatch = useDispatch();
  const FaceBotCount = useSelector((state) => state.config.facebot_count);
  const current = useSelector(state => state.onboard.currentStep);
  const [IsAvatarId, setAvatarId] = useState('');
  const [kbName, setKbName] = useState('');
  const [kbDescription, setKbDescription] = useState('');
  const [kbLibrary, setKbLibrary] = useState();
  const [showResumeAlert, setShowResumeAlert] = useState(false);

  const StepItems = [
    { title: 'Creating FaceBot', disabled: true },
    { title: 'Complete', disabled: true },
  ];


  // Show alert if user refreshes mid-onboarding
  // useEffect(() => {
  //   if (current !== 0 && FaceBotCount !== null) {
  //     console.log('Resuming onboarding...', current, FaceBotCount);
      
  //     setShowResumeAlert(true);
  //     setTimeout(() => setShowResumeAlert(false), 5000); // Auto-dismiss after 5s
  //   }
  // }, []);

  useEffect(() => {
    dispatch(setStep(0));
  }, []);

  const renderStepContent = () => {
    switch (current) {
      case 0:
        return (
          <CreatingBot 
            setCurrent={(step) => dispatch(setStep(step))}
            IsAvatarId={IsAvatarId}
            setAvatarId={setAvatarId}
            onFinish={handleFinish}
          />
        );
        
      default:
        return <Complete />;
    }
  };
  const onChange = (value) => {
    if (value >= 0 && value <= 1) {
      dispatch(setStep(value));
    }
  };
  const handleFinish = () => {
    // Move to Complete step
    dispatch(setStep(1));
  };

  return (
    <div className={styles.wrapper}>

      <Steps
        current={current}
        onChange={onChange}
        size="small"
        items={StepItems}
        style={{ paddingTop: 60, paddingInline: 90, paddingBottom: 25 }}
      />
      <Layout style={{ width: '100%', height: 'calc(100vh - 100px)', overflow: 'auto' }}>
        {renderStepContent()}
      </Layout>
    </div>
  );
};

export default Onboard;
